import { render, staticRenderFns } from "./SubFields.vue?vue&type=template&id=16e2c93e"
import script from "./SubFields.vue?vue&type=script&lang=js"
export * from "./SubFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports